import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, CopyButton, Group, Stack, Text, Textarea } from "@mantine/core";
import { AppModal } from "./AppModal";
export const EmbeddedCodeModal = ({ organizationId, opened, close }) => {
    const embedCode = `<div id="therapprove-embed"></div>
<script
  src="${import.meta.env.VITE_LANDING_URL}/embed.js"
  data-src="${import.meta.env.VITE_LANDING_URL}/organizations/${organizationId}/embedded-priority-view-form"
  data-container="#therapprove-embed"
  data-height="auto"
  async
></script>
  `;
    return (_jsx(AppModal, { title: "Embed Lead Form", opened: opened, onClose: close, size: "lg", children: _jsxs(Stack, { mt: 10, gap: "md", children: [_jsx(Text, { variant: "paragraph", children: "To embed Therapprove's website lead form, copy the following code and paste it into the HTML of the web page where you'd like it to appear:" }), _jsx(Textarea, { variant: "codeBlock", value: embedCode, readOnly: true, rows: 10 }), _jsx(Group, { mt: 10, ml: "auto", children: _jsx(CopyButton, { value: embedCode, timeout: 1000, children: ({ copied, copy }) => (_jsx(Button, { variant: "filled", color: copied ? "teal" : "primary", onClick: copy, children: copied ? "Copied!" : "Copy Code" })) }) })] }) }));
};
